export const ADD_STORE = "ADD_STORE";
export const ADD_STORE_SUCCESS = "ADD_STORE_SUCCESS";
export const GET_STORES = "GET_STORES";
export const GET_STORES_SUCCESS = "GET_STORES_SUCCESS";
export const DELETE_STORE = "DELETE_STORE";
export const DELETE_STORE_SUCCESS = "DELETE_STORE_SUCCESS";
export const EDIT_STORE = "EDIT_STORE";
export const EDIT_STORE_SUCCESS = "EDIT_STORE_SUCCESS";
